import React, { Component } from 'react'

export default class CategoriesScrollView extends Component {
    state = {
        list: [
            { icon: '/images/c1.png', name: 'Breakfast', key: '1' },
            { icon: '/images/c1.png', name: 'Hot Drinks', key: '2' },
            { icon: '/images/c1.png', name: 'Cold Drinks', key: '3' },
            { icon: '/images/c1.png', name: 'Pizza', key: '4' },
            { icon: '/images/c1.png', name: 'Berger', key: '5' },
            { icon: '/images/c1.png', name: 'Sandwich', key: '6' },
            { icon: '/images/c1.png', name: 'Salad', key: '7' },
            { icon: '/images/c1.png', name: 'Deseart', key: '8' },
            { icon: '/images/c1.png', name: 'vine', key: '9' },
            { icon: '/images/c1.png', name: 'Breakfast', key: '10' },
            { icon: '/images/c1.png', name: 'Breakfast', key: '11' },
            { icon: '/images/c1.png', name: 'Breakfast', key: '12' },
            { icon: '/images/c1.png', name: 'Breakfast', key: '13' },
            { icon: '/images/c1.png', name: 'Breakfast', key: '14' },
            { icon: '/images/c1.png', name: 'Breakfast', key: '15' },
            { icon: '/images/c1.png', name: 'Breakfast', key: '16' },
            { icon: '/images/c1.png', name: 'Breakfast', key: '17' },
        ]
    }
    selectCategories = (key) => {
        this.setState({ main: key })
    }

    render() {
        return (
            <div>
                {this.props.type == 'icon' &&
                    <div className='flexc p-3 sc-gray' style={{ overflowX: 'auto' }}>
                        {this.state.list.map((prop, index) => {
                            return (
                                <button className='flexcc flex-column mrd-3 p-2 br-10' style={{ border: (this.state.main == prop.key ? '1px solid #007aff' : '1px solid #fff'), minWidth:'80px' }} onClick={() => this.selectCategories(prop.key)}>
                                    <img width={40} src={prop.icon} />
                                    <p style={{ color: (this.state.main == prop.key ? '#007aff' : '#444'), }}>{prop.name}</p>
                                </button>
                            )
                        })}
                    </div>
                }
                {this.props.type == 'smallicon' &&
                    <div className='flexc p-3 sc-gray' style={{ overflowX: 'auto' }}>
                        {this.state.list.map((prop, index) => {
                            return (
                                <button className='flexc mrd-1 px-3 py-1 br-30' style={{ border: (this.state.main == prop.key ? '1px solid #007aff' : '1px solid #fff') }} onClick={() => this.selectCategories(prop.key)}>
                                    <img className='mrd-3' width={24} src={prop.icon} />
                                    <p style={{ color: (this.state.main == prop.key ? '#007aff' : '#444'), whiteSpace: 'nowrap' }}>{prop.name}</p>
                                </button>
                            )
                        })}
                    </div>
                }
                {this.props.type == 'text' &&
                    <div className='flexc p-3 sc-gray' style={{ overflowX: 'auto' }}>
                        {this.state.list.map((prop, index) => {
                            return (
                                <button className='flexcc flex-column mrd-1 px-3 py-1 br-30' style={{ border: (this.state.main == prop.key ? '1px solid #007aff' : '1px solid #fff') }} onClick={() => this.selectCategories(prop.key)}>
                                    {/* <img width={40} src={prop.icon} /> */}
                                    <p style={{ color: (this.state.main == prop.key ? '#007aff' : '#444'), whiteSpace: 'nowrap' }}>{prop.name}</p>
                                </button>
                            )
                        })}
                    </div>
                }
            </div>
        )
    }
}
